export default __webpack_public_path__ + "static/media/dbe0788d-533f-4e84-b346-1f68c19853f9.e4a42f13.woff";